import React, { JSX } from 'react'

import { ButtonInner } from '~/components/component-library/Button/components/ButtonInner'
import { ButtonWithDropdown } from '~/components/component-library/Button/components/ButtonWithDropdown'
import { type ButtonProps } from '~/components/component-library/Button/types'
import { Tooltip } from '~/components/component-library/Tooltip'
import { cn } from '~/utils/tailwind-utils'

export {
  type ButtonProps,
  type ButtonDropdownOption,
} from '~/components/component-library/Button/types'

export { buttonVariants } from '~/components/component-library/Button/styles'

export const Button = ({
  ref,
  dropdownOptions,
  ...props
}: ButtonProps & {
  ref?: React.RefObject<HTMLButtonElement | HTMLAnchorElement | null>
}): JSX.Element => {
  const { isDisabled, disabledReason } = props

  if (dropdownOptions && dropdownOptions.length > 0) {
    return (
      <ButtonWithDropdown
        {...props}
        dropdownOptions={dropdownOptions}
        ref={ref}
      />
    )
  }

  if (isDisabled && disabledReason) {
    return (
      <Tooltip
        content={disabledReason}
        // Size the trigger to the button so the tooltip centers on it
        className={cn('!cursor-not-allowed', { 'w-fit': !props.fullWidth })}
        preventCloseOnClick
      >
        <ButtonInner {...props} ref={ref} />
      </Tooltip>
    )
  }
  return <ButtonInner {...props} ref={ref} />
}

Button.displayName = 'Button'
